import React from "react";
import { Col, Row } from "react-bootstrap";
import gptLogo  from "../../Assets/tool/gpt.png";
import dallLogo  from "../../Assets/tool/dall.png";
import mjLogo  from "../../Assets/tool/mj.png";
import cuiLogo  from "../../Assets/tool/cui.png";
import sdLogo  from "../../Assets/tool/sd.png";
import runLogo from "../../Assets/tool/run.png";
import elLogo  from "../../Assets/tool/el.png";
import jmLogo   from "../../Assets/tool/jm.png";

import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiVercel,
  SiMacos,
} from "react-icons/si";

function Toolstack() {
  const tools = [
    { src: gptLogo, alt: "ChatGPT" },
    { src: dallLogo, alt: "DALL·E（OpenAI）" },
    { src: mjLogo, alt: "Midjourney" },
    { src: cuiLogo, alt: "ComfyUI" },
    { src: sdLogo, alt: "Stable Diffusion" },
    { src: runLogo, alt: "Runway ML" },
    { src: elLogo, alt: "ElevenLabs" },
    { src: jmLogo, alt: "即梦AI" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tools.map((tool, index) => (
        <Col xs={4} md={2} className="tech-icons" key={index}>
          <img
            src={tool.src}
            alt={tool.alt}
            style={{
              width: "80px",
              height: "80px",
              objectFit: "contain",
              marginBottom: "10px",
            }}
          />
          <p style={{ marginTop: "8px", fontSize: "18px", color: "#ccc" }}>
           {tool.alt}
          </p>
        </Col>
      ))}
    </Row>
  );
}
export default Toolstack;
